import React from "react"
import PropTypes from "prop-types"
import { Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap"
import { values } from "lodash"

import { getText } from '../lib/text.js'

// filter by tag
const TagsFilter = ({ selectedTag, style, data, onChange, label }) => (
  <Form inline style={{ display: "inline-block", ...style }}>
    <FormGroup>
      {
        label && (
          <ControlLabel style={{ marginRight: 15 }}>{label}: </ControlLabel>
        )
      }
      <FormControl
        componentClass="select"
        value={selectedTag || "all"}
        onChange={evt => onChange(evt.target.value)}
      >
        <option value="all">Todo (sin filtro)</option>
        { values(data).map(c => <option key={c._id} value={c._id}>{getText(c.name)}</option>) }
      </FormControl>
    </FormGroup>
  </Form>
)

TagsFilter.propTypes = {
  selectedTag: PropTypes.string.isRequired,
  style: PropTypes.object,
  data: PropTypes.any.isRequired, // #TODO
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string
}

TagsFilter.defaultProps = {
  style: {},
  label: getText("Filtro de etiquetas")
}

export default TagsFilter
